// renamed Moment typings as it seemed to conflict with other uses
import moment from 'moment-timezone'

export const getMaintenanceNoticeMessage = (
    isActive: boolean,
    startTS: string,
    endTS: string,
) => {
    if (!startTS?.length || !endTS?.length) {
        return false
    }
    const userTimezone = moment.tz.guess()
    const maintenanceStartMoment = moment(startTS).utc().tz(userTimezone)
    const maintenanceEndMoment = moment(endTS).utc().tz(userTimezone)

    return (
        isActive &&
        maintenanceStartMoment.isValid() &&
        maintenanceEndMoment.isValid() &&
        `The Fictiv application will be temporarily down for maintenance on ${maintenanceStartMoment.format(
            'MMMM',
        )} ${maintenanceStartMoment.format(
            'DD',
        )}, ${maintenanceStartMoment.format(
            'YYYY',
        )} from ${maintenanceStartMoment.format(
            'hh:mm A',
        )} to ${maintenanceEndMoment.format('hh:mm A')}, ${moment
            .tz(userTimezone)
            .format('z')}.`
    )
}
